/**
 * Opens the mega menu on hover for pointer devices.
 *
 * Dawn builds the menu from <details>/<summary>, which only toggles on
 * click. Touch devices keep that behaviour -- a hover handler there would
 * fire on the tap that is meant to follow the link.
 *
 * A short close delay covers the gap between the summary and the panel,
 * so the menu does not snap shut while the pointer travels into it.
 */
(function () {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!canHover.matches) return;

  const CLOSE_DELAY = 140;

  document.querySelectorAll('header-menu').forEach((menu) => {
    const details = menu.querySelector('details');
    if (!details) return;

    const summary = details.querySelector('summary');
    let timer;

    const open = () => {
      clearTimeout(timer);
      // Close any sibling that is still open so only one panel shows.
      document.querySelectorAll('header-menu details[open]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
      details.setAttribute('open', '');
      summary?.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      timer = setTimeout(() => {
        details.removeAttribute('open');
        summary?.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    };

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', close);

    // Clicking the summary would otherwise toggle it shut again while the
    // pointer is still inside, since hover has already opened it.
    summary?.addEventListener('click', (e) => {
      if (details.hasAttribute('open')) e.preventDefault();
    });
  });

  // Leaving the header entirely closes whatever is open.
  document.querySelector('.header-wrapper')?.addEventListener('mouseleave', () => {
    document.querySelectorAll('header-menu details[open]').forEach((d) => {
      d.removeAttribute('open');
      d.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  });
})();
